var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { AppHeader } from './components';
import styles from './HeaderLayout.module.css';
export const HeaderLayout = ({ children }) => (_jsxs(_Fragment, { children: [_jsx(AppHeader, {}), _jsx(Box, { align: "center", className: styles.MainContent, isFullHeight: true, isFullWidth: true, justify: "center", orientation: "vertical", scrollableY: true, children: children })] }));
_react_refresh_temp_1 = HeaderLayout;
$RefreshReg$(_react_refresh_temp_1, "HeaderLayout");
